import { ApiService, ApiServiceGetResponse } from '@services'
import { NotClaimAvailabilityBackend } from '@store'


export type ClaimApi = {
  "claim_message": {
      "mode": number,
      "address": string,
      "state_init": string,
      "payload": string,
      "amount": string
  },
  "jetton": string,
  "available_jetton_amount": string,
  "total_jetton_amount": string,
  "claimed_jetton_amount": string
}

export const getNotClaimAvailabilityApi = async (): Promise<
  ApiServiceGetResponse<NotClaimAvailabilityBackend>
> => {
  const { ok, data } = await ApiService.get({
    endpoint: '/api/v1/user/not-claim/availability',
  })

  return { ok, data: data || null }
}
export const donateRewardApi = async (): Promise<
  ApiServiceGetResponse<null>
> => {
  const { ok, data } = await ApiService.post({
    endpoint: '/api/v1/user/not-claim/donate',
  })

  return { ok, data: data || null }
}

export const airdropdApi = async (): Promise<
  ApiServiceGetResponse<ClaimApi>
> => {
  const { ok, data, error_code } = await ApiService.get({
    endpoint: '/api/v1/user/not-claim/airdrop',
  })

  return { ok, data: data || null, error_code }
}
